import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { RegionPage } from "@/components/calv/RegionPage";

export const Route = createFileRoute("/en/regions/wuerzburg")({
  head: () => {
    const h = pageHead("region:wuerzburg", "en");
    return { meta: h.meta, links: h.links };
  },
  component: () => <RegionPage slug="wuerzburg" locale="en" />,
});
